
import useButtonText from './useButtonText'
import useToast from './useToast'
import useCheckTransaction from './useCheckTransaction'



function useSendButton(initButtonText) {
    const {
        button,
        loadingButton,
        initButton,
        setDisabled,
        setButtonText
    } = useButtonText(initButtonText)
    const {open} = useToast()
    const {openTx} = useCheckTransaction()

    return {
        button,
        setButtonText,
        loading: loadingButton,
        init: initButton,
        txError: info => openTx('fail', info),
        fail: info => open(info, 'error'),
        successful: info => open(info),
        setDisabled
    }
}

export default useSendButton